import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { ACCOUNT_STALE_TIME_MS, STALE_CHECK_INTERVAL_MS } from '../constants';
export const useCurrentAccountWithStalenessCheck = fetchAccount => {
  const $ = _c(6);
  const lastFetchTimeRef = useRef(0);
  let t0;
  let t1;
  if ($[0] !== fetchAccount) {
    t0 = () => {
      fetchAccount();
      lastFetchTimeRef.current = Date.now();
    };
    t1 = [fetchAccount];
    $[0] = fetchAccount;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] !== fetchAccount) {
    t2 = () => {
      const checkStaleData = () => {
        const timeSinceLastFetch = Date.now() - lastFetchTimeRef.current;
        if (timeSinceLastFetch > ACCOUNT_STALE_TIME_MS) {
          fetchAccount();
          lastFetchTimeRef.current = Date.now();
        }
      };
      const interval = setInterval(checkStaleData, STALE_CHECK_INTERVAL_MS);
      return () => clearInterval(interval);
    };
    t3 = [fetchAccount];
    $[3] = fetchAccount;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
};